<template>
  <BaseChartPanel
    :title="t('domain_blocks_stat_bar.title')"
    :date="date"
    :chart-height="stylesChart.heightBarChart"
    :chart-options="chartOptions"
    :series="categories?.length ? series : []"
    @refresh="loadData"
    @update:date="date = $event"
  />
</template>

<script setup>
import { computed } from "vue";
import { useCountryStatDomainBlocksStore } from "@/store/Analytic/chart/country-stat-domain-blocks";
import { stylesChart } from "@/tools/tooltipChart";
import useBarChart from "@/mixins/apexChart/barChart";
import { t } from "@/controllerLK/AvalLocalization";
import useFilterDate from "@/mixins/apexChart/filterDate";
import BaseChartPanel from "./BaseChartPanel.vue";

const statStorage = useCountryStatDomainBlocksStore();

const { date } = useFilterDate(loadData);

async function loadData() {
  await statStorage.loadStat(date.value?.[0], date.value?.[1]);
}

const categories = computed(() => {
  return (statStorage.items || []).map((item) => {
    const name = item.name || "";
    return name.length > 45 ? name.slice(0, 45) + "..." : name;
  });
});

const series = computed(() => {
  const data = (statStorage.items || []).map((item) => item.data);
  return [{
    name: " ",
    data: data
  }];
});

const { chartOptions } = useBarChart(
  {
    titleText: t("domain_blocks_stat_bar.title"),
  },
  categories,
  series
);
</script>